<template>
  <a class="swiss-delta-logo" href="https://swissdelta.com">
    <svg version="1.1" id="swiss_delta_logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 113.4 124.5" enable-background="new 0 0 113.4 124.5" xml:space="preserve">
<g>
	<path fill="#201E1B" d="M106.8,117.7l-6.1-13.9l-6,13.9H106.8z M107.7,119.6h-14l-2.1,4.8h-3.3l10.1-22.7h4.4l10.3,22.7h-3.3
		L107.7,119.6z M80.7,104.1v20.3h-3.1v-20.3h-9v-2.4h21v2.4H80.7z M56.6,101.8v20.3h14.2v2.4H53.5v-22.7H56.6z M33.3,103.9v7.7h14
		v2.2h-14v8.5h14.6v2.2H30.2v-22.7h17.7v2.2H33.3z M5.7,122.3h9c3.3,0,5.4-0.5,6.4-1.6c1-1.1,1.4-3.5,1.4-7.3c0-4.1-0.4-6.7-1.2-7.8
		c-0.8-1.1-2.8-1.6-6-1.6H5.7V122.3z M2.6,124.5v-22.7h12.8c3.9,0,6.6,0.7,8,2.1c1.4,1.4,2.1,4.2,2.1,8.2c0,4.9-0.6,8.2-1.9,9.9
		c-1.3,1.6-3.7,2.5-7.5,2.5H2.6z M104.8,82.5c6.9,0.5,8.6,1.4,8.6,6.7c0,3.8,0.2,7.6-10.1,7.6c-5.9,0-9.9-0.1-9.9-7.7h5.9
		c0,2.4,0.9,2.7,3.9,2.7c2.9,0,3.9-0.2,3.9-2.1c0-2-0.3-2-3.2-2.2l-1.4-0.1c-5.7-0.4-9.1-0.4-9.1-7c0-6.7,3.7-7.1,9.8-7.1
		c5.1,0,9.4,0.1,9.4,6.5v1h-5.9c0-2.4-1-2.4-3.5-2.4c-3.3,0-3.6,0.7-3.6,2c0,1.9,0.9,1.9,2.5,2L104.8,82.5z M81.4,82.5
		c6.9,0.5,8.6,1.4,8.6,6.7c0,3.8,0.2,7.6-10.1,7.6c-5.9,0-9.8-0.1-9.8-7.7H76c0,2.4,0.9,2.7,3.9,2.7c2.9,0,3.9-0.2,3.9-2.1
		c0-2-0.3-2-3.2-2.2l-1.4-0.1c-5.7-0.4-9.1-0.4-9.1-7c0-6.7,3.7-7.1,9.8-7.1c5.1,0,9.4,0.1,9.4,6.5v1h-5.9c0-2.4-1-2.4-3.5-2.4
		c-3.3,0-3.6,0.7-3.6,2c0,1.9,0.9,1.9,2.5,2L81.4,82.5z M65.8,96.6h-6.2V73.4h6.2V96.6z M50.5,73.4h6.2l-5.1,23.2h-8.9l-3.2-14.5
		h-0.2l-3.4,14.5H27l-5-23.2h6.3l3.3,17.9h0.2l4.4-17.9h6.4l4.2,17.9H47L50.5,73.4z M11.3,82.5c6.9,0.5,8.6,1.4,8.6,6.7
		c0,3.8,0.2,7.6-10.1,7.6c-5.9,0-9.8-0.1-9.8-7.7h5.9c0,2.4,0.9,2.7,3.9,2.7c2.9,0,3.9-0.2,3.9-2.1c0-2-0.3-2-3.2-2.2l-1.4-0.1
		C3.4,86.9,0,87,0,80.3c0-6.7,3.7-7.1,9.8-7.1c5.1,0,9.4,0.1,9.4,6.5v1h-5.9c0-2.4-1-2.4-3.5-2.4c-3.3,0-3.6,0.7-3.6,2
		c0,1.9,0.9,1.9,2.5,2L11.3,82.5z"/>
	<path fill="#201E1B" d="M72.7,40.8H61.5V52h-9.3V40.8H40.9v-9.3h11.4V20.2h9.3v11.4h11.2V40.8z M85.3,50.2L85.3,50.2
		c0,0,0-0.1-0.1-0.2c-0.1-0.1-0.1-0.3-0.2-0.6c-0.2-0.5-0.4-1.1-0.7-1.7c-0.5-1.3-1.1-2.8-1.4-3.5c-2.4-5.6-5.2-11.3-8.5-17
		c-3.6-6.2-7.4-11.9-11.4-17c-0.4-0.5-1.1-1.4-1.7-2.2c-0.6-0.8-1.3-1.6-1.4-1.7c-0.8-0.8-1.9-1.2-3-1.2c-0.7,0-1.5,0.2-2.2,0.6
		c-0.3,0.2-0.5,0.3-0.7,0.6c0,0,0,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.3-0.6,0.8-1,1.3c-0.7,0.9-1.5,1.9-1.9,2.4
		c-4,5.1-7.8,10.8-11.3,17c-3.5,6.1-6.5,12.2-9,18.2c-0.4,1-1.7,3.9-1.8,4.2v0c-0.2,0.5-0.3,1-0.3,1.5c0,2,1.3,3.6,3.1,4.2
		c0.3,0.1,0.7,0.2,1.1,0.2h0.1l0.1,0c7.5,1.2,15.6,1.9,24.1,1.9c5.5,0,10.8-0.3,15.9-0.8c1.4-0.1,6.2-0.7,9.5-1.2
		c0.9-0.1,1.9-0.9,2.6-2c0,0,0-0.1,0.1-0.3c0,0,0,0,0-0.1C84.9,53.1,85,53,85,53v0l0,0c0.2-0.6,0.4-1.2,0.4-1.8
		C85.4,50.9,85.3,50.6,85.3,50.2 M88.6,54.5c-0.1,0.2-0.2,0.4-0.2,0.4v0l0,0v0c0,0.1-0.1,0.2-0.2,0.5c-1.1,2-3,3.6-5.4,4
		c-3.4,0.6-8.2,1.1-9.7,1.3c-5.2,0.5-10.7,0.8-16.3,0.8c-8.7,0-16.9-0.7-24.6-1.9c-0.7,0-1.3-0.2-2-0.4c-3.4-1-5.9-4.2-5.9-8
		c0-1,0.2-2,0.5-3c0.1-0.2,0.1-0.3,0.3-0.7c0.1-0.3,0.3-0.8,0.5-1.2c0.4-0.9,0.8-1.9,1-2.4c2.5-6.1,5.6-12.4,9.2-18.7
		c3.6-6.3,7.6-12.1,11.6-17.4c0.6-0.8,2.5-3.3,3.3-4.2c0.1-0.2,0.2-0.3,0.4-0.4c0.4-0.4,0.9-0.7,1.4-1c1.3-0.8,2.8-1.1,4.2-1.1
		c2.1,0,4.2,0.8,5.7,2.3c0.3,0.3,0.4,0.5,0.7,0.8c0.3,0.3,0.6,0.7,1,1.2c0.7,0.9,1.4,1.8,1.8,2.3c4.1,5.3,8,11.2,11.7,17.5
		c3.4,5.8,6.3,11.7,8.7,17.5c0.5,1.2,1.6,3.9,2.2,5.4c0.2,0.5,0.3,0.8,0.4,1.2c0.1,0.6,0.2,1.2,0.2,1.9
		C89.3,52.3,89.1,53.5,88.6,54.5 M90.2,49.1c-0.1-0.5-0.3-0.9-0.5-1.4c-0.6-1.6-1.7-4.2-2.2-5.5c-2.5-5.8-5.4-11.7-8.8-17.6
		C75.1,18.3,71.1,12.4,67,7c-0.4-0.5-1.1-1.4-1.8-2.3c-0.3-0.4-0.7-0.9-1-1.2c-0.3-0.3-0.5-0.6-0.8-0.9C61.6,0.9,59.2,0,56.8,0
		c-1.6,0-3.2,0.4-4.7,1.3C51.5,1.6,51,2,50.5,2.5l-0.9,0.8l0.1,0.1c-1,1.2-2.5,3.2-3.1,3.9c-4.1,5.3-8.1,11.2-11.7,17.5
		c-3.6,6.3-6.7,12.6-9.3,18.8c-0.2,0.5-0.6,1.5-1,2.4c-0.2,0.5-0.4,0.9-0.5,1.2c-0.1,0.3-0.2,0.5-0.3,0.7c-0.4,1-0.6,2.2-0.6,3.4
		c0,4.3,2.8,7.9,6.7,9c0.7,0.2,1.4,0.3,2.2,0.4c7.7,1.2,16,1.9,24.7,1.9c5.6,0,11.1-0.3,16.4-0.8c1.6-0.2,6.3-0.7,9.8-1.3
		c2.8-0.5,4.9-2.3,6.2-4.5c0.1-0.2,0.2-0.3,0.2-0.4c0-0.1,0-0.1,0.1-0.1l0,0l0,0l0,0l0,0c0,0,0.1-0.2,0.2-0.5
		c0.5-1.2,0.8-2.5,0.8-3.8C90.4,50.5,90.4,49.8,90.2,49.1"/>
</g>
</svg>
  </a>
</template>

<script>
  export default {
    name: 'sd-logo'
  }
</script>

<style lang="scss" scoped>
  #swiss_delta_logo {
    position: relative;
    display: block;
    width: auto;
    height: 100%;
  }
  a.swiss-delta-logo {
    position: relative;
    display: block;
    width: auto;
    height: 10mm;
    cursor: pointer;
    text-decoration: none;
    &:hover:after, &:focus:after, &:active:after {
      display: none;
    }
  }
</style>
